<template>
    <v-container class="mb-4">
        <v-data-table :headers="headers" :items="dati" :search="search" item-key="Id" :no-data-text="''"
            no-results-text="Nessun dato trovato" mobile-breakpoint="0" @click:row="rowClicked"
            :expanded.sync="expanded" single-expand hide-default-footer :items-per-page="-1">
            <!-- RIGA PRINCIPALE -->
            <template v-slot:item="{ item }">
                <tr @click="setCliente(item); rowClicked(item)" style="cursor:pointer"
                    :style="{ backgroundColor: item.Blocca ? '#ff5050' : '' }">
                    <td>{{ item.TipoCliente }}</td>
                    <td>{{ item.RagioneSociale }}</td>
                    <td>{{ item.PartitaIVA }}</td>
                    <td>{{ item.Email }}</td>
                    <td>{{ item.Telefono }}</td>
                </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" style="padding:0; background-color: #f0f0f0;">
                    <v-col>
                        <v-row class="ma-0 pa-0">
                            <v-select v-model="item.TipoCliente" label="Tipo" :items="tipoClienti" class="mr-2"
                                style="max-width: 250px !important;" />
                            <v-text-field v-model="item.RagioneSociale" label="Ragione sociale" class="mr-2" />
                            <v-text-field v-model="item.PartitaIVA" label="Partita IVA" />
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-text-field v-model="item.Email" label="Email" />
                            <v-text-field v-model="item.Telefono" label="Telefono" />
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-textarea v-model="item.Note" label="Note" rows="2" />
                        </v-row>

                        <v-card outlined v-for="(ind, i) in item.IndirizziDett" :key="i"
                            style="background-color: #f0f0f0;" class="ma-2 pt-4 pl-2 d-flex align-center">
                            <v-text-field v-model="ind.Indirizzo" label="Indirizzo" class="mr-2" dense />

                            <v-text-field v-model="ind.Latitudine" label="Latitudine" type="number" class="mr-2"
                                dense />

                            <v-text-field v-model="ind.Longitudine" label="Longitudine" type="number" class="mr-2"
                                dense />

                            <v-btn icon @click.stop="removeIndirizzo(item, i)">
                                <v-icon color="red">delete</v-icon>
                            </v-btn>
                        </v-card>

                        <v-row class="ma-0 pa-0">
                            <v-btn color="primary" @click.stop="salvaRiga(item)" class="ma-4">
                                <v-icon>save</v-icon> Salva dati
                            </v-btn>
                            <v-btn small @click.stop="eliminaRiga(item)" class="ma-4">
                                <v-icon>delete</v-icon> Elimina cliente
                            </v-btn>
                            <v-spacer />
                            <v-btn @click.stop="addIndirizzo(item)" class="ma-4" small>
                                <v-icon color="green">add</v-icon> Aggiungi indirizzo
                            </v-btn>
                        </v-row>
                    </v-col>
                </td>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
import { get_tipoClienti, get_clientiPotenziali, salva_clientiPotenziali, del_clientiPotenziali } from '@/api/api.agenti';

export default {
    props: {
        search: { type: String, default: "" },
    },

    data: () => ({
        dati: [],
        headers: [
            { text: "Tipo cliente", align: "center", value: "TipoCliente" },
            { text: "Cliente", align: "center", value: "RagioneSociale" },
            { text: "PartitaIVA", align: "center", value: "PartitaIVA" },
            { text: "EMail", align: "center", value: "Email" },
            { text: "Telefono", align: "center", value: "Telefono" }
        ],
        expanded: [],
        singleExpand: false,
        rowClickedData: [],
        selectedRow: {},
        codClienteSel: -1,
        tipoClienti: [],
    }),

    methods: {
        async caricaDati() {

            let res = await get_tipoClienti();
            this.tipoClienti = res.data;

            let par = "";
            let userSwitch = this.$store.getters["user/getUserSwitch"];
            if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
            else if (this.$store.getters["user/getCodice"])
                par = "agente" + "/" + this.$store.getters["user/getCodice"];

            res = await get_clientiPotenziali(par);
            this.dati = res.data;
        },

        setCliente(props) {
            this.selectedRow = props;
        },

        rowClicked(props) {
            this.rowClickedData = props;
            this.expanded = [];
            props.expanded = !props.expanded;
            if (!props.expanded) {
                this.ResetExpanded();
                return;
            }
            this.expanded.push(props);
            this.codClienteSel = props.Id;
        },

        ResetExpanded() {
            this.dati.forEach((el) => {
                el.expanded = false;
            });
        },

        addIndirizzo(item) {
            if (!item.IndirizziDett) item.IndirizziDett = [];

            const maxCod = item.IndirizziDett.length
                ? Math.max(...item.IndirizziDett.map(i => i.CodiceIndirizzo))
                : 0;

            item.IndirizziDett.push({
                CodiceIndirizzo: maxCod + 1,
                Indirizzo: "",
                Latitudine: "",
                Longitudine: "",
            });
        },

        removeIndirizzo(item, index) {
            item.IndirizziDett.splice(index, 1);
        },

        async salvaRiga(item) {
            let res = await salva_clientiPotenziali("", item)
            if (res.data == "OK") {
                this.$toast.info("Dati salvati");
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },
        async eliminaRiga(item) {

            let confirm = await this.$root.$confirm(
                "Elimina",
                "Vuoi eliminare il cliente e tutti i suoi dati?"
            );
            if (!confirm) return;

            let res = await del_clientiPotenziali("", item)
            if (res.data == "OK") {
                this.$toast.info("Cliente eliminato");
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        }
    },

    mounted() {
        this.caricaDati();
    }
}
</script>